import { Station } from "../../types";

// --- SWEDISH STATIONS (Public + Commercial) ---
export const SWEDISH_STATIONS: Station[] = [
  // --- NATIONAL PUBLIC (Sveriges Radio) ---
  {
    id: "sr-p1",
    name: "Sveriges Radio P1",
    country: "Sweden",
    countryCode: "SE",
    provider: "sr",
    streamUrl: "https://http-live.sr.se/p1-mp3-192",
    website: "https://sverigesradio.se/p1",
    logoUrl: "/img/stations/sr-p1.png",
    tags: ["public-service", "news", "culture", "talk"],
    bitrate: 192,
    language: ["Swedish"],
    votes: 2000,
    clickTrend: 50,
    state: "National",
  },
  {
    id: "sr-p2",
    name: "Sveriges Radio P2",
    country: "Sweden",
    countryCode: "SE",
    provider: "sr",
    streamUrl: "https://http-live.sr.se/p2musik-mp3-192",
    website: "https://sverigesradio.se/p2",
    logoUrl: "/img/stations/sr-p2.png",
    tags: ["public-service", "classical", "jazz", "music"],
    bitrate: 192,
    language: ["Swedish"],
    votes: 1200,
    clickTrend: 20,
    state: "National",
  },
  {
    id: "sr-p3",
    name: "Sveriges Radio P3",
    country: "Sweden",
    countryCode: "SE",
    provider: "sr",
    streamUrl: "https://http-live.sr.se/p3-mp3-192",
    website: "https://sverigesradio.se/p3",
    logoUrl: "/img/stations/sr-p3.png",
    tags: ["public-service", "pop", "youth", "entertainment"],
    bitrate: 192,
    language: ["Swedish"],
    votes: 1800,
    clickTrend: 45,
    state: "National",
  },

  // --- COMMERCIAL HITS (Mix Megapol, RIX FM) ---
  {
    id: "mix-megapol",
    name: "Mix Megapol",
    country: "Sweden",
    countryCode: "SE",
    provider: "bauer",
    streamUrl:
      "https://live-bauerse-fm.sharp-stream.com/mixmegapol_instream_se_aacp",
    website: "https://radioplay.se/mixmegapol",
    logoUrl: "/img/stations/mix-megapol-custom.jpg",
    tags: ["pop", "hits", "commercial", "80s", "90s"],
    bitrate: 128,
    language: ["Swedish"],
    votes: 2500,
    clickTrend: 60,
    state: "National",
  },
  {
    id: "rix-fm",
    name: "RIX FM",
    country: "Sweden",
    countryCode: "SE",
    provider: "viaplay",
    streamUrl: "https://fm01-ice.stream.khz.se/fm01_aac",
    website: "https://www.ilikeradio.se/rixfm/",
    logoUrl: "/img/stations/rix-fm-custom.png",
    tags: ["pop", "hits", "commercial", "top 40"],
    bitrate: 128,
    language: ["Swedish"],
    votes: 2400,
    clickTrend: 55,
    state: "National",
  },
  {
    id: "dansbandskanalen",
    name: "Dansbandskanalen",
    country: "Sweden",
    countryCode: "SE",
    provider: "dbmedia",
    streamUrl: "https://stream.dbmedia.se/dbkMP3",
    website: "https://www.dansbandskanalen.se/",
    logoUrl: "/img/stations/dansbandskanalen.png",
    tags: ["dansband", "schlager", "country", "classic"],
    bitrate: 128,
    language: ["Swedish"],
    votes: 3000,
    clickTrend: 70,
    state: "Skåne",
  },

  // --- REGIONAL (Location Based) ---
  {
    id: "sr-p4-stockholm",
    name: "P4 Stockholm",
    country: "Sweden",
    countryCode: "SE",
    provider: "sr",
    streamUrl: "https://http-live.sr.se/p4stockholm-mp3-192",
    website: "https://sverigesradio.se/stockholm",
    logoUrl: "/img/stations/sr-p4.png",
    tags: ["public-service", "local", "news", "variety"],
    bitrate: 192,
    language: ["Swedish"],
    votes: 1500,
    clickTrend: 30,
    state: "Stockholm",
  },
  {
    id: "sr-p4-goteborg",
    name: "P4 Göteborg",
    country: "Sweden",
    countryCode: "SE",
    provider: "sr",
    streamUrl: "https://http-live.sr.se/p4goteborg-mp3-192",
    website: "https://sverigesradio.se/goteborg",
    logoUrl: "/img/stations/sr-p4.png",
    tags: ["public-service", "local", "news", "variety"],
    bitrate: 192,
    language: ["Swedish"],
    votes: 1400,
    clickTrend: 28,
    state: "Västra Götaland",
  },
  {
    id: "sr-p4-malmohus",
    name: "P4 Malmöhus",
    country: "Sweden",
    countryCode: "SE",
    provider: "sr",
    streamUrl: "https://http-live.sr.se/p4malmo-aac-192",
    website: "https://sverigesradio.se/malmohus",
    logoUrl: "/img/stations/sr-p4.png",
    tags: ["public-service", "local", "news", "variety"],
    bitrate: 192,
    language: ["Swedish"],
    votes: 1300,
    clickTrend: 25,
    state: "Skåne",
  },
  {
    id: "sr-p4-jamtland",
    name: "P4 Jämtland",
    country: "Sweden",
    countryCode: "SE",
    provider: "sr",
    streamUrl: "https://http-live.sr.se/p4jamtland-aac-192",
    website: "https://sverigesradio.se/jamtland",
    logoUrl: "/img/stations/sr-p4.png",
    tags: ["public-service", "local", "news", "variety"],
    bitrate: 192,
    language: ["Swedish"],
    votes: 800,
    clickTrend: 15,
    state: "Jämtland",
  },
  {
    id: "sr-p4-dalarna",
    name: "P4 Dalarna",
    country: "Sweden",
    countryCode: "SE",
    provider: "sr",
    streamUrl: "https://http-live.sr.se/p4dalarna-mp3-192",
    website: "https://sverigesradio.se/dalarna",
    logoUrl: "/img/stations/sr-p4.png",
    tags: ["public-service", "local", "news", "variety"],
    bitrate: 192,
    language: ["Swedish"],
    votes: 900,
    clickTrend: 18,
    state: "Dalarna",
  },

  // --- COMMERCIAL ROCK & CLASSICS ---
  {
    id: "rockklassiker",
    name: "Rockklassiker",
    country: "Sweden",
    countryCode: "SE",
    provider: "bauer",
    streamUrl:
      "https://live-bauerse-fm.sharp-stream.com/rockklassiker_instream_se_aacp",
    website: "https://radioplay.se/rockklassiker",
    logoUrl: "/img/stations/rockklassiker.png",
    tags: ["rock", "classic rock", "commercial", "70s", "80s", "90s"],
    bitrate: 128,
    language: ["Swedish"],
    votes: 2200,
    clickTrend: 50,
    state: "National",
  },
  {
    id: "bandit-rock",
    name: "Bandit Rock Stockholm",
    country: "Sweden",
    countryCode: "SE",
    provider: "nent",
    streamUrl: "https://fm02-ice.stream.khz.se/fm02_mp3",
    website: "https://www.banditrock.se/",
    logoUrl: "/img/stations/bandit-rock.png",
    tags: ["rock", "metal", "hard rock", "commercial"],
    bitrate: 128,
    language: ["Swedish"],
    votes: 1900,
    clickTrend: 45,
    state: "Stockholm",
  },

  // --- COMMERCIAL POP & HITS ---
  {
    id: "nrj-sweden",
    name: "NRJ Sweden",
    country: "Sweden",
    countryCode: "SE",
    provider: "nent",
    streamUrl: "https://fm03-ice.stream.khz.se/fm03_mp3",
    website: "https://www.nrj.se/",
    logoUrl: "/img/stations/nrj.png",
    tags: ["pop", "hits", "commercial", "top 40", "dance"],
    bitrate: 128,
    language: ["Swedish"],
    votes: 2100,
    clickTrend: 48,
    state: "National",
  },
  {
    id: "star-fm",
    name: "STAR FM",
    country: "Sweden",
    countryCode: "SE",
    provider: "bauer",
    streamUrl: "https://live-bauerse-fm.sharp-stream.com/star_instream_se_aacp",
    website: "https://radioplay.se/starfm",
    logoUrl: "/img/stations/star-fm.png",
    tags: ["pop", "hits", "commercial", "adult contemporary"],
    bitrate: 128,
    language: ["Swedish"],
    votes: 1700,
    clickTrend: 40,
    state: "National",
  },

  // --- EASY LISTENING & CLASSICS ---
  {
    id: "lugna-favoriter",
    name: "Lugna Favoriter",
    country: "Sweden",
    countryCode: "SE",
    provider: "bauer",
    streamUrl:
      "https://live-bauerse-fm.sharp-stream.com/lugnafavoriter_instream_se_aacp",
    website: "https://radioplay.se/lugnafavoriter",
    logoUrl: "/img/stations/lugna-favoriter.png",
    tags: ["easy listening", "soft rock", "adult contemporary", "relaxation"],
    bitrate: 128,
    language: ["Swedish"],
    votes: 1600,
    clickTrend: 35,
    state: "National",
  },
  {
    id: "vinyl-fm",
    name: "Vinyl FM",
    country: "Sweden",
    countryCode: "SE",
    provider: "nent",
    streamUrl: "https://fm08-ice.stream.khz.se/fm08_mp3",
    website: "https://www.vinylfm.se/",
    logoUrl: "/img/stations/vinyl-fm.png",
    tags: ["classic hits", "oldies", "70s", "80s", "90s"],
    bitrate: 128,
    language: ["Swedish"],
    votes: 1400,
    clickTrend: 30,
    state: "National",
  },
  {
    id: "retro-fm",
    name: "Retro FM",
    country: "Sweden",
    countryCode: "SE",
    provider: "nent",
    streamUrl:
      "https://live-bauerse-fm.sharp-stream.com/retrofm_instream_se_aacp",
    website: "https://radioplay.se/retrofm",
    logoUrl: "/img/stations/retro-fm.png",
    tags: ["retro", "80s", "90s", "classic hits", "nostalgia"],
    bitrate: 128,
    language: ["Swedish"],
    votes: 1500,
    clickTrend: 32,
    state: "National",
  },
  {
    id: "gold-fm",
    name: "Gold FM",
    country: "Sweden",
    countryCode: "SE",
    provider: "independent",
    streamUrl: "https://stream.dbmedia.se/goldfmMP3",
    website: "https://www.goldfm.se/",
    // logoUrl: "/img/stations/gold-fm.png", // File missing, using generic fallback
    tags: ["oldies", "gold", "classic hits", "60s", "70s", "80s"],
    bitrate: 128,
    language: ["Swedish"],
    votes: 1200,
    clickTrend: 25,
    state: "Växjö",
  },
  {
    id: "svensk-pop",
    name: "Svensk Pop",
    country: "Sweden",
    countryCode: "SE",
    provider: "independent",
    streamUrl: "https://stream.dbmedia.se/svenskpopMP3",
    website: "https://www.svenskpop.se/",
    logoUrl: "/img/stations/svensk-pop.png",
    tags: ["swedish pop", "svensktopp", "pop", "domestic"],
    bitrate: 128,
    language: ["Swedish"],
    votes: 1300,
    clickTrend: 28,
    state: "National",
  },

  // --- NICHE / SPECIALIZED ---
  {
    id: "housetime-fm",
    name: "HouseTime.FM",
    country: "Sweden",
    countryCode: "SE",
    provider: "independent",
    streamUrl: "https://mp3.stream.tb-group.fm/ht.mp3",
    website: "https://www.housetime.fm/",
    // logoUrl: "/img/stations/housetime-fm.png", // Note: Add valid image file to assets before uncommenting
    tags: ["house", "electronic", "dance", "edm", "techno"],
    bitrate: 192,
    language: ["English"],
    votes: 1100,
    clickTrend: 22,
    state: "National",
  },
  {
    id: "guldkanalen",
    name: "Guldkanalen",
    country: "Sweden",
    countryCode: "SE",
    provider: "independent",
    streamUrl: "https://stream.dbmedia.se/gulkanalMP3",
    website: "https://www.guldkanalen.se/",
    logoUrl: "/img/stations/guldkanalen.png",
    tags: ["oldies", "gold", "nostalgia", "50s", "60s", "70s"],
    bitrate: 128,
    language: ["Swedish"],
    votes: 1000,
    clickTrend: 20,
    state: "National",
  },
];

// --- NORWEGIAN STATIONS ---
export const NRK_STATIONS: Station[] = [];

// --- INTERNATIONAL STATIONS ---
export const RTP_STATIONS: Station[] = [
  {
    id: "bbc-world-service",
    name: "BBC World Service",
    country: "United Kingdom",
    countryCode: "GB",
    provider: "bbc",
    streamUrl: "https://stream.live.vc.bbcmedia.co.uk/bbc_world_service",
    website: "https://www.bbc.co.uk/worldserviceradio",
    tags: ["news", "global", "talk"],
    bitrate: 128,
    language: ["English"],
    votes: 5000,
    clickTrend: 60,
    logoUrl: "/img/stations/bbc-custom.png",
    state: "London",
  },
  {
    id: "kexp",
    name: "KEXP 90.3 FM",
    country: "United States",
    countryCode: "US",
    provider: "kexp",
    streamUrl: "https://kexp-mp3-128.streamguys1.com/kexp128.mp3",
    website: "https://kexp.org",
    tags: ["music", "alternative", "indie"],
    bitrate: 128,
    language: ["English"],
    votes: 3000,
    clickTrend: 40,
    logoUrl: "/img/stations/kexp-hd.png",
    state: "Washington",
  },
];

export const ABC_STATIONS: Station[] = [];
export const RNZ_STATIONS: Station[] = [];
